import { render, staticRenderFns } from "./personalInfoForm.vue?vue&type=template&id=4984dbb3&scoped=true"
import script from "./personalInfoForm.vue?vue&type=script&lang=js"
export * from "./personalInfoForm.vue?vue&type=script&lang=js"
import style0 from "./personalInfoForm.vue?vue&type=style&index=0&id=4984dbb3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984dbb3",
  null
  
)

export default component.exports